import { Bloom, ChromaticAberration, EffectComposer, Noise, SMAA, Vignette } from '@react-three/postprocessing';
import { BlendFunction } from 'postprocessing';

// Cinematic stack (research §6): selective Bloom (only toneMapped=false
// emissives exceed threshold 1), vignette, faint grain; CA reserved for the
// journey's warp pulses on T3. Whole composer gated by perf tier.
export function PostFX({ perfTier, warpIntensity = 0 }) {
  if (!perfTier.postFX) return null;
  return (
    <EffectComposer multisampling={0}>
      <SMAA />
      <Bloom mipmapBlur luminanceThreshold={1} luminanceSmoothing={0.08} intensity={0.9 + warpIntensity * 0.8} />
      <Vignette darkness={0.55} offset={0.42} />
      <Noise premultiply blendFunction={BlendFunction.OVERLAY} opacity={0.035} />
      {perfTier.ca ? (
        // warp-pulse only, per the design note above. The old constant base
        // offset (0.0006/0.0012) smeared EVERY frame by ~1-2 physical px of
        // RGB separation — WebGL text could never render crisp under it.
        <ChromaticAberration offset={[warpIntensity * 0.004, warpIntensity * 0.006]} />
      ) : null}
    </EffectComposer>
  );
}
